'use strict';

module.exports = 0xff19;


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/array/var/FULL_WIDTH_NINE.js
// module id = 745
// module chunks = 0